<template>
  <!-- https://lanhu-oss-2537-2.lanhuapp.com/ -->
  <!-- @/assets/images/index/ -->
  <div style="background-color: rgba(241, 245, 255, 1)">
    <div class="app-container">
      <template>
        <div class="indexpage ">
          <div class="indexbackground ">

            <!-- <div class="box_29 flex-row justify-between"> -->

            <!-- <div class="group_45 flex-col justify-between"> -->
            <div class="indexhead">
              <!-- <div class="box_3 flex-row"> -->
              <!-- <div class="group_1 flex-col"></div> -->
              <div class="indexhead-group_1g"></div>
              <img class="indexhead-label_5" referrerpolicy="no-referrer"
                src="@/assets/images/index/FigmaDDSSlicePNGede81fbb7325198723423480ab8229c1.png" />
              <!-- <div class="group_46 flex-col justify-between"> -->
              <div class="indexhead-group_46 ">
                <div class="indexhead-section_4"></div>
                <span class="indexhead-text_10">让每一次投标更高效、更精准、更安全</span>
              </div>
              <div class="indexhead-group_3"></div>
              <div class="indexhead-group_4"></div>
              <img class="indexhead-image_4" referrerpolicy="no-referrer"
                src="@/assets/images/index/FigmaDDSSlicePNGaafcc2dd9fe23948b32fcc4fc87cf128.png" />
            </div>
            <div class="  indexbackground-body">
              <div class="indexbackground-body-left ">
                <div class="headtext  ">
                  <div class="headtext-left"></div>
                  <span class="headtext-right">编写完整投标文件</span>
                </div>
                <div class="headtext2">
                  <span class="headtext2-text_12">商务标+技术标</span>
                </div>

                <div class="topleftone flex-col" @click="anwanzheng">
                  <div class="topleftone1">

                    <!-- <div class="image-wrapper_12 flex-row"> -->
                    <div class="topleftone1-image1">
                      <img class="" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNGbc93703077fee5e7021fcfc2382e4c63.png" />
                    </div>

                    <!-- <div class="group_8 flex-row justify-end">
                      <div class="group_9 flex-col"></div>  -->
                       <div class="topleftone1-group8 ">
                      <div class="topleftone1-group9 "></div>
                      <!-- <div class="group_10 flex-col"></div> -->
                      <!-- <div class="group_11 flex-col"></div> -->
                      <div class="topleftone1-group_12">
                        <div class="topleftone1-section_6"></div>
                      </div>
                    </div>
                    <img class="topleftone1-image_5" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG6c5fa10b04f2cbe7eab832c06f408dd5.png" />
                  </div>
                  <!-- <div class="group_48 flex-row"> -->
                  <div class=" flex-row">
                    <div class="topleftone2">
                      <span class="topleftone2-text_13">立即使用</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="indexbackground-body-right">
                <div class="headtext">
                  <div class="headtext-left"></div>
                  <span class="headtext-right">仅编写技术方案</span>
                </div>
                <div class="topright1 flex-row justify-between">
                  <div class="toprightone flex-col" @click="anwenjian">
                    <div class="toprightone1 flex-row">
                      <div class="image-group1 flex-col">
                        <img class="image-group1-1" referrerpolicy="no-referrer"
                          src="@/assets/images/index/FigmaDDSSlicePNGd85e51cf144ed6f1a72bcc2c334d3307.png" />
                        <img class="image-group1-2" referrerpolicy="no-referrer"
                          src="@/assets/images/index/FigmaDDSSlicePNGf48109852ea5cea07f10978632294233.png" />
                      </div>
                      <img class="image-group1-3" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNG1259187dcbbf38406e14cc0a5a4931e6.png" />
                    </div>
                    <div class="toprightone2 flex-col justify-between">
                      <span class="toprightone2-text1">按招标文件生成</span>
                      <span class="toprightone2-text2">上传招标文件，智能解析</span>
                    </div>
                  </div>
                  <div class="toprightone flex-col" @click="anwbiaozhuan">
                    <!-- <div class="group_16 flex-col"> -->
                    <div class="toprightone1 flex-col">
                      <div class="group_17 flex-col"></div>
                      <div class="group_18 flex-col">
                        <div class="image-wrapper_4 flex-col">
                          <img class="image_6" referrerpolicy="no-referrer"
                            src="@/assets/images/index/FigmaDDSSlicePNG8b8970c9943a6d1a247564efebf5fddd.png" />
                        </div>
                      </div>
                    </div>
                    <div class="toprightone2 flex-col justify-between">
                      <span class="toprightone2-text1">按评分标准生成</span>
                      <span class="toprightone2-text2">提供评分标准，快速定位</span>
                    </div>
                  </div>
                  <div class="toprightone flex-col" @click="anmulu">
                    <!-- <div class="image-wrapper_5 flex-col"> -->
                    <div class="toprightone1 flex-col">
                      <img class="image_7" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNGd563d049f81530d533671079b9a4f602.png" />
                    </div>
                    <!-- <div class="text-group_54 flex-col justify-between"> -->
                    <div class="toprightone2 flex-col justify-between">
                      <span class="toprightone2-text1">按标书目录生成</span>
                      <span class="toprightone2-text2">适配个性需求</span>
                    </div>
                  </div>
                  <div class="toprightone flex-col" @click="anlishi">
                    <!-- <div class="image-wrapper_6 flex-col"> -->
                    <!-- <div class="toprightone1 flex-col"> -->
                    <div class="toprightone1 ">
                      <img class="image_8" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNG6a04c50883a9f89d8f64afd4a665fe4a.png" />
                    </div>
                    <!-- <div class="text-group_55 flex-col justify-between"> -->
                    <div class="toprightone2 flex-col justify-between">
                      <span class="toprightone2-text1">按历史文件生成</span>
                      <span class="toprightone2-text2">一句话描述</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="indexpage-bottom flex-col"> -->
            <div class="indexpage-bottom ">
              <div class="indexpage-bottom-head flex-row">
                <div class="indexpage-bottom-head-textleft"></div>
                <span class="indexpage-bottom-head-text">我的标书</span>
                <!-- <div>
                <span class="text_24">项目类型：</span>
                <div class="block_11 flex-row">
                  <div class="image-text_48 flex-row justify-between">
                    <span class="text-group_8">全部</span>
                    <img class="thumbnail_15" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8bb148c2f25aa59dc455c8c8a575eb06.png" />
                  </div>
                </div>
                <span class="text_25">创建时间：</span>
                <div class="block_12 flex-row">
                  <span class="text_26">不限</span>
                  <img class="thumbnail_16" referrerpolicy="no-referrer"
                    src="@/assets/images/index/FigmaDDSSlicePNG8bb148c2f25aa59dc455c8c8a575eb06.png" />
                </div>
                </div> -->

                <div style="float: right;right: 50px;position: absolute;">
                  <span>项目类型：</span>
                   <el-select v-model="mvalue" placeholder="项目类型">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>

 <span class="">创建时间：</span>
   <el-date-picker
      v-model="value2"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      align="right">
    </el-date-picker>

    <!-- <span> {{ value2 }}</span> -->
                </div>
              </div>
              <div class="indexpage-bottom-grid_5 flex-row" id="grid5">
                <div class="indexpage-bottom-grid_5-box_9 flex-col indexpage-bottom-grid_5-box9first">
                  <div class="imagetext flex-col justify-between">
                    <img class="thumbnail" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNGa2f6be5f0205d37dffff351604b957c5.png" />
                    <span class="textgroup">新建标书</span>
                  </div>
                  <span class="imagetext2">AI帮你写标书</span>
                </div>
                <div class="indexpage-bottom-grid_5-box_9 ">
                  <div class="indexpage-bottom-grid_5-box_9-textgroup flex-col">
                    <span class="indexpage-bottom-grid_5-box_9-textgroup-head">标书名称标书名称标书名称标书名...</span>
                    <span class="indexpage-bottom-grid_5-box_9-textgroup-type">完整标书/技术方案</span>
                    <span class="indexpage-bottom-grid_5-box_9-textgroup-riqi">2025年9月1日</span>
                  </div>
                  <div class="group_49 flex-row justify-between">
                    <div class="image-text_50 flex-row justify-between">
                      <img class="thumbnail_18" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNG079d06be7e8e577808ab3b2b9bf3ac45.png" />
                      <span class="text-group_11">编写中...</span>
                    </div>
                    <img class="image_9" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8c42b8b022879058b7f5ddbaecf7a59e.png" />
                  </div>
                </div>
                <div class="box_9 flex-col">
                  <div class="text-group_57 flex-col justify-between">
                    <span class="text_31">标书名称标书名称标书名称</span>
                    <span class="text_32">完整标书/技术方案</span>
                    <span class="text_33">2025年9月1日</span>
                  </div>
                  <div class="block_33 flex-row justify-between">
                    <div class="image-text_51 flex-row justify-between">
                      <img class="thumbnail_19" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNG079d06be7e8e577808ab3b2b9bf3ac45.png" />
                      <span class="text-group_13">编写中...</span>
                    </div>
                    <img class="image_10" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8c42b8b022879058b7f5ddbaecf7a59e.png" />
                  </div>
                </div>
                <div class="box_9 flex-col">
                  <div class="text-group_58 flex-col justify-between">
                    <span class="text_34">标书名称标书名称标书名称标书名...</span>
                    <span class="text_35">完整标书/技术方案</span>
                    <span class="text_36">2025年9月1日</span>
                  </div>
                  <div class="section_21 flex-row justify-between">
                    <div class="image-text_52 flex-row justify-between">
                      <img class="thumbnail_20" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNGd69e20c11cb2b977cc855e90649ae05a.png" />
                      <span class="text-group_15">已完成</span>
                    </div>
                    <img class="image_11" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8c42b8b022879058b7f5ddbaecf7a59e.png" />
                  </div>
                </div>
                <div class="box_9 flex-col">
                  <div class="text-group_59 flex-col justify-between">
                    <span class="text_37">标书名称标书名称标书名称标书名...</span>
                    <span class="text_38">完整标书/技术方案</span>
                    <span class="text_39">2025年9月1日</span>
                  </div>
                  <div class="box_34 flex-row justify-between">
                    <div class="image-text_53 flex-row justify-between">
                      <img class="thumbnail_21" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNG079d06be7e8e577808ab3b2b9bf3ac45.png" />
                      <span class="text-group_17">编写中...</span>
                    </div>
                    <img class="image_12" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8c42b8b022879058b7f5ddbaecf7a59e.png" />
                  </div>
                </div>
                <div class="box_9 flex-col">
                  <div class="text-group_60 flex-col justify-between">
                    <span class="text_40">标书名称标书名称标书名称</span>
                    <span class="text_41">完整标书/技术方案</span>
                    <span class="text_42">2025年9月1日</span>
                  </div>
                  <div class="block_34 flex-row justify-between">
                    <div class="image-text_54 flex-row justify-between">
                      <img class="thumbnail_22" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNG079d06be7e8e577808ab3b2b9bf3ac45.png" />
                      <span class="text-group_19">编写中...</span>
                    </div>
                    <img class="image_13" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8c42b8b022879058b7f5ddbaecf7a59e.png" />
                  </div>
                </div>
                <div class="box_9 flex-col">
                  <div class="text-group_61 flex-col justify-between">
                    <span class="text_43">标书名称标书名称标书名称标书名...</span>
                    <span class="text_44">完整标书/技术方案</span>
                    <span class="text_45">2025年9月1日</span>
                  </div>
                  <div class="box_35 flex-row justify-between">
                    <div class="image-text_55 flex-row justify-between">
                      <img class="thumbnail_23" referrerpolicy="no-referrer"
                        src="@/assets/images/index/FigmaDDSSlicePNGd69e20c11cb2b977cc855e90649ae05a.png" />
                      <span class="text-group_21">已完成</span>
                    </div>
                    <img class="image_14" referrerpolicy="no-referrer"
                      src="@/assets/images/index/FigmaDDSSlicePNG8c42b8b022879058b7f5ddbaecf7a59e.png" />
                  </div>
                </div>
              </div>
              <!-- <div class="block_35 flex-row">
                <div class="image-wrapper_7 flex-col">
                  <img class="thumbnail_24" referrerpolicy="no-referrer"
                    src="@/assets/images/index/FigmaDDSSlicePNG0f18409ba1e69e4e2305d0f70d60449c.png" />
                </div>
                <span class="text_46">1</span>
                <div class="image-wrapper_8 flex-col">
                  <img class="thumbnail_25" referrerpolicy="no-referrer"
                    src="@/assets/images/index/FigmaDDSSlicePNGc610ee07a9a7ee6576c27300c38e2746.png" />
                </div>
                <span class="text_47">跳转至</span> <span class="text_48">1</span>
                <div class="group_22 flex-col"></div>
                <div class="group_23 flex-col"></div>
              </div> -->
              
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      style="padding: 0px 20px !important;"
      @pagination="getList"/>
            </div>
            <!-- </div> -->
            <!-- </div> -->
          </div>
        </div>
      </template>




    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      constants: {},


      mvalue:"全部",
       options: [{
          value: '选项1',
          label: '项目1'
        }, {
          value: '选项2',
          label: '项目2'
        }, {
          value: '选项3',
          label: '项目3'
        }, {
          value: '选项4',
          label: '项目4'
        }, {
          value: '选项5',
          label: '项目5'
        }],

 pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
    


       // 总条数
      total: 6,
        // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        bidCode: null,
        appCode: null,
        fileName: null,
        fileType: null,
        appContent: null,
        version: null,
      },
    };
  },
    created() {
    // this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      listBidappends(this.queryParams).then(response => {
        this.bidappendsList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    anwanzheng() {
      this.$router.push({ path: '/biddingdocument/bid/index' });
    },

    anwenjian() {
      this.$router.push({ path: '/biddingdocument/bid/index1' });
    },
    anwbiaozhuan() {
      this.$router.push({ path: '/biddingdocument/bid/index2' });
    },
    anmulu() {
      this.$router.push({ path: '/biddingdocument/bid/index3' });
    },
    anlishi() {
      this.$router.push({ path: '/biddingdocument/bid/index4' });
    },
  },
};
</script>
<style src="./index1/common.css" />
<style src="./index1/index.css" />
<style lang="scss" scoped>
.app-container {
  padding: 20px;
  position: absolute;
  height: 100%;
  width: 100%;
  // background: red;

  .indexpage {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    /* width: 1440px; */
    width: 100%;
    height: 100%;
    // overflow: auto;
    // overflow-y: auto;

    .indexbackground {
      background-color: rgba(241, 245, 255, 1);
      width: 100%;
      height: 100%;

// 20251010
     display: flex;
    flex-direction: column;
// 20251010

      .indexhead {
        position: relative;
        /* width: 1224px; */
        width: 100%;
        height: 70px;
        // background: url(/static/img/FigmaDDSSlicePNG36dc2d9….36dc2d99.png) 100% no-repeat;
        background: url("../assets/images/index/FigmaDDSSlicePNG36dc2d9931f9b0c32e0111c7391fb1dc.png") 100% no-repeat;
        background-size: 100% 100%;


        // display: -webkit-box;
        // display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        // -ms-flex-direction: row;
        flex-direction: row;

        &-group_1g {
          background-color: rgba(86, 203, 255, 0.85);
          width: 79px;
          height: 34px;
          margin-top: 36px;
        }

        &-label_5 {
          width: 39px;
          height: 30px;
          margin: 6px 0 0 91px;
        }

        &-group_46 {
          width: 649px;
          height: 53px;
          margin-left: 4px;

          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;

          display: flex;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
        }

        &-group_3 {
          background-color: rgba(130, 142, 255, 0.45);
          width: 110px;
          height: 31px;
          margin-left: 89px;
        }

        &-section_4 {
          background-color: rgba(75, 193, 255, 1);
          width: 192px;
          height: 39px;
        }

        &-text_10 {
          width: 501px;
          height: 22px;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 28px;
          letter-spacing: 2px;
          font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 22px;
          margin: -8px 0 0 148px;
        }

        &-group_4 {
          background-color: rgba(123, 128, 255, 0.35);
          width: 80px;
          height: 18px;
          margin: 52px 41px 0 42px;
        }

        &-image_4 {
          position: absolute;
          left: 185px;
          top: 0;
          width: 114px;
          height: 80px;
        }

      }

      &-body {
        width: 100%;
        // height: 330px;
        height: 280px;
        margin-top: 15px;

        flex-direction: row;

        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
         &-left{
            height: 280px;
  background: url("../assets/images/index/FigmaDDSSlicePNG66bf458cdfd354367afd266ebf379d54.png")
    100% no-repeat;
  background-size: 100% 100%;
  width: 33%;
  position: relative;
  justify-content: flex-center;
         }

         &-right{
            // height: 330px;
            height: 280px;
  background: url("../assets/images/index/FigmaDDSSlicePNG368f7e1e87fe5c40941817b7d2812e09.png")
    100% no-repeat;
  background-size: 100% 100%;
  width: calc(67% - 20px);
         }

         .headtext{
          width: 170px;
    height: 30px;
    // margin: 24px 0 0 20px;
    margin: 0px 0 0 20px;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    &-left{
          background-color: rgba(0, 96, 255, 1);
    border-radius: 38px;
    width: 4px;
    height: 20px;
    margin-top: 5px;
        display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    }
    &-right{
      width: 158px;
    height: 30px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.85);
    font-size: 20px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 30px;
    }
         }

         .headtext2{
          width: 104px;
    height: 22px;
    margin: 1px 0 0 31px;
    &-text_12 {
    width: 104px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
}
         }

      }
    }
    &-bottom{
      background-color: rgba(255, 255, 255, 1);
    border-radius: 12px;
    width: 100%;
    // height: 430px;
    flex: 1;
    margin-top: 20px;
    &-head{
      // width: 1183px;
      width: 100%;
    height: 32px;
    // margin: 0px 0 0 20px
    padding: 5px 0 0 20px;
    &-text{
    width: 79px;
    height: 30px;
    overflow-wrap: break-word;
    color: rgba#000000d9(0, 0, 0, 0.85);
    font-size: 20px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 30px;
    margin: 1px 0 0 8px;
    }
    &-textleft{
      background-color: rgba(0, 96, 255, 1);
    border-radius: 38px;
    width: 4px;
    height: 20px;
    margin-top: 6px;
    }

    }
    &-grid_5 {
    /* width: 1184px; */
    width: 100%;
    height: 336px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 20px 0 0 20px;
    &-box_9{
    /* background-color: rgba(0, 96, 255, 0.04); */
    border-radius: 8px;
    width: 284px;
    height: 160px;
    /* border: 1px solid rgba(0, 96, 255, 0.85); */
    border: 2px solid rgb(219 235 255);
    margin: 0 16px 16px 16px;
    &-textgroup{
    width: 252px;
    height: 74px;
    margin: 16px 0 0 16px;
    &-head{
    width: 252px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    }
    &-type{

    width: 118px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 4px;
    }

    &-riqi{
    width: 90px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 4px;

    }

    }

    }

    &-box9first{
    border: 3px dotted rgb(219 235 255) !important;

      .imagetext {
    width: 56px;
    height: 50px;
    margin: 54px 0 0 112px;
    .thumbnail {
    width: 20px;
    height: 20px;
    margin-left: 18px;
}

.textgroup{
    width: 56px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 8px;
}
       }
      .imagetext2 {
    width: 83px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 0 34px 99px;
}
    }
}
    }
  }
}

.topright1 {
  /* width: 768px; */
  width: 100%;
  // height: 236px;
  padding: 10px 20px 20px 20px;
}

.toprightone {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  /* width: 177px; */
  width: calc(25% - 20px);
  height: 225px;
  // justify-content: flex-center;

  display: flex;
  /* 垂直居中 */
  align-items: center;
  /* 水平居中 */
  justify-content: center;

      -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

}

.toprightone1 {
  background-color: rgba(236, 246, 255, 1);
  border-radius: 70px;
  width: 80px;
  height: 80px;
  /* margin: 40px 0 0 49px; */
  position: relative;

  .image-group1 {
  position: relative;
  width: 49px;
  height: 50px;
  background: url("../assets/images/index/FigmaDDSSlicePNGc49748a3ce5799c2734bcf3456b31d28.png")
    100% no-repeat;
  background-size: 100% 100%;
  margin: 16px 0 0 13px;
  &-1 {
    position: absolute;
    left: 48px;
    top: -6px;
    width: 7px;
    height: 7px;
}
&-2 {
  position: absolute;
  left: 29px;
  top: 46px;
  width: 7px;
  height: 7px;
}
&-3 {
  width: 5px;
  height: 5px;
  margin: 48px 12px 0 1px;
}
}
}

.toprightone2 {
  width: 152px;
  height: 50px;
  /* margin: 26px 0 40px 13px; */
  &-text1 {
  width: 100%;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  // margin-left: 21px;
}
&-text2{
    width: 100%;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    line-height: 22px;
    // margin-top: 6px;
}
}

.topleftone {

  width: 100%;
  // height: 100%;
  height: 60%;
  display: flex;
  /* 垂直居中 */
  align-items: center;
  /* 水平居中 */
  justify-content: center;

  .topleftone1 {
    width: 191px;
    height: 217px;
    &-image1{
          width: 13px;
    height: 18px;
    }
    &-group8{
        position:relative;
  /* left: 94px; */
  /* top: 56px; */
  width: 191px;
  height: 217px;
  background: url("../assets/images/index/FigmaDDSSlicePNG9b56c20504fd4a28686ac08b02a1e66a.png")
    100% no-repeat;
  background-size: 100% 100%;
    }
    &-group9{
        background-color: rgba(241, 244, 255, 1);
  width: 9px;
  height: 45px;
    }
    &-group_12 {
          background-color: rgba(241, 244, 255, 1);
    height: 51px;
    width: 15px;
    /* position: absolute; */
    /* left: 143px; */
    /* top: 105px; */
    position: relative;
    }
    &-section_6 {
  width: 3px;
  height: 61px;
  background: url("../assets/images/index/FigmaDDSSlicePNG8f0030bd4b513efe20d4a84c95a1e75f.png")
    100% no-repeat;
  background-size: 100% 100%;
  margin-left: 14px;
}
    &-image_5 {
    position: absolute;
    right: 147px;
    top: 165px;
    width: 72px;
    height: 73px;
}
  }

  .topleftone2{
        display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
        background-color: rgba(255, 255, 255, 1);
    border-radius: 20px;
    height: 38px;
    border: 1px gradient;
    width: 221px;
    &-text_13 {
    width: 60px;
    height: 18px;
    overflow-wrap: break-word;
    color: rgba(0, 96, 255, 1);
    font-size: 15px;
    letter-spacing: 1px;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin: 10px 0 0 81px;
}
  }
}

.flex-col {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.flex-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
}
.justify-between {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
</style>
